export const CONNECTORS_START_CHARGE_URL = (connectorId: number) =>
  `/chargepoints/connectors/${connectorId}/start_charge/` as const;
export const CONNECTORS_STOP_CHARGE_URL = (connectorId: number) =>
  `/chargepoints/connectors/${connectorId}/stop_charge/` as const;
export const CONNECTORS_MANUAL_FIELDS_START_CHARGE_URL = (
  connectorId: number,
  vehicleNumberPlate: string,
  odometerValue: string
) =>
  `/chargepoints/connectors/${connectorId}/${vehicleNumberPlate}/${odometerValue}/manual_fields_start_charge/` as const;
